<template>
    <div class="animated fadeIn gofixTab contractEquipmentTab assetManagement bgV2 sContractSchedule">
        <div class="boxShadow h-100 setBorderRadius">
            <div :class="['d-flex h-100 position-relative', {'assetManagement-collapse': is_hide}]">
                <div class="assetManagement-left h-100" ref="panelLeft">
                    <template>
                        <gofix-card fullContent title="Projects" class="contractTree contractEquimentTree">
                            <template slot="gofixCard:right_header">
                                <div class="cursor-pointer" @click="collapse">
                                    <img src="img/unfold_right.png" alt="icon" width="8px" height="12px">
                                    <img src="img/unfold_left.png" alt="icon" width="8px" height="12px" class="ml-4-px">
                                </div>
                            </template>
                            <gofix-form-input label="Search" v-model="search"></gofix-form-input>
                            <div class="contenAbsolute pd-0" v-bind:class="{'run-loading':loading.scontracts}">
                                <div class="tree-view-properties">
                                    <template v-for="(item, index) in filteredItems">
                                        <div class="cursor-pointer" @click.stop="loadSchedule(item)" :key="index">
                                            <gofix-card :class="{'item-selected': general.scontract && general.scontract.id == item.id }" :title="item.contract_reference_number || '--'" classHeader="mb-0 px-4 py-2" class="mb-0 position-relative" collapse :isShowCollapse="false">
                                                <template slot="gofixCard:after_card" v-if="general.scontract && general.scontract.id == item.id">
                                                    <div class="cursor-pointer remove-selected" @click.stop="general.scontract = null">
                                                        <span id="remove-selected-item">
                                                            <img src="img/disable.png" alt="icon" height="16px">
                                                        </span>
                                                        <b-tooltip target="remove-selected-item" title="Cancel Item Selection"></b-tooltip>
                                                    </div>
                                                </template>
                                                <p class="mb-2 px-4">{{ item.contract_title || '--' }}</p>
                                            </gofix-card>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </gofix-card>
                    </template>
                </div>
                <div class="assetManagement-right h-100" ref="rightPanel">
                    <schedule name-table="preventive-maintenance-property-schedule" :settings="settings" :scontract="this.general.scontract" @reloadList="getSContracts" ref="propertySchedule"></schedule>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import LiquorTree from "liquor-tree";
    const schedule = () => import("./schedule.vue")
   
    export default {
        name: "scontract-schedule-list",
        components: {
            [LiquorTree.name]: LiquorTree,
            schedule
        },
        data() {
            return {
                is_hide: false,
                settings: {
                    showBtnMassSchedule: true,
                    showDropDownMaint: true,
                },
                loading: {
                    scontracts: false
                },
                general: {
                    scontract: null
                },
                scontracts: [],
                search: ''
            }
        },
        watch: {
            ClientContractID: function(val) {
                this.getSContracts();
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: "ContractController/ClientContractID"
            }),
            filteredItems:function()
            {
                var self = this;
                return this.scontracts.filter(function(item) {
                    let contract_reference_number = item.contract_reference_number
                    if(contract_reference_number === null) contract_reference_number = ''

                    let project_type = item.project_type
                    if(project_type === null) project_type = ''

                    let contract_title = item.contract_title
                    if(contract_title === null) contract_title = ''
                    return contract_reference_number.toLowerCase().indexOf(self.search.toLowerCase())>=0 || project_type.toLowerCase().indexOf(self.search.toLowerCase())>=0 || contract_title.toLowerCase().indexOf(self.search.toLowerCase())>=0;
                });        
            }
        },
        created() {
            this.getSContracts();
        },
        methods: {
            collapse() {
                this.is_hide = !this.is_hide;
                let left = this.$refs.propertySchedule.$refs.gofixTable.$refs.vueScrollbar.left;
                let maxRight = this.$refs.propertySchedule.$refs.gofixTable.$refs.vueScrollbar.scrollAreaWidth - this.$refs.propertySchedule.$refs.gofixTable.$refs.vueScrollbar.scrollWrapperWidth;
                if(this.is_hide && (left >= maxRight)) {
                    this.$nextTick(() => {
                        this.$refs.propertySchedule.$refs.gofixTable.$refs.vueScrollbar.normalizeHorizontal(left - this.$refs.panelLeft.clientWidth);
                        let time = setTimeout(() => {
                            this.$refs.propertySchedule.$refs.gofixTable.$refs.vueScrollbar.calculateSize();
                            clearTimeout(time);
                        }, 500);
                    });
                }
            },
            async getSContracts() {
                if(!this.ClientContractID || !this.ClientContractID.id) {
                    this.scontracts = []
                    return
                }
                this.loading.scontracts = true
                let tableRequest = {
                    filter: { client_contract_id: this.ClientContractID.id },
                    page: 1,
                    limit: -1
                }

                await this.$store.dispatch("SContractProjectController/getSContract", tableRequest)
                    .then(response => {
                        this.scontracts = response.items;
                        this.loading.scontracts = false
                    })
                    .catch(err => {
                        this.loading.scontracts = false
                    })
            },
            loadSchedule(item) {
                this.general.scontract = item
            }
        }
    }
</script>
<style lang="scss" scoped>
    .sContractSchedule {
        .contenAbsolute {
            top: 57px;
            right: -6px;
        }
        .gofixCard {
            border-radius: 0;
        }
        .item-selected {
            background-color: #FCDDCC;
        }
        .remove-selected {
            position: absolute;
            right: 20px;
            top: 0;
            transform: translate(-50%);
            bottom: 0;
            padding-top: 9px;
        }
    }
</style>